<app-data-grid
  [viewId]="viewId"
  [title]="title"
  [icon]="icon"
  [columnDefs]="columnDefs"
  [fetchRows]="fetchRows"
></app-data-grid>
